import { gql } from '__generated__';

export default gql(`
  query GetMailchimpAudiences($project_id: ID!, $event_id: ID!, $include_event: Boolean!) {
    project(id: $project_id) {
      id
      mailchimp_connection {
        id
        audiences {
          id
          name
        }
      }
    }
    event(id: $event_id) @include(if: $include_event) {
      id
      title
    }
  }
`);
